import EntityTypeEnum from 'common/enums/entityTypeEnum'
import CustomLoginInterface from 'common/types/entities/CustomLoginInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createNewCustomLogin(
  parentId: string,
  masterBlockId?: MasterBlockId,
): CustomLoginInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.CustomLogin, parentId, masterBlockId),
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 5,
    },
    childIds: [],
  }
}
